import type { JobDetails } from '@seek/hirer-job-information';
import type { IJobInformation } from '../JobInformation';
import { JobPostChannel } from '../types';

export const getJobDetails = (
  jobInfo?: IJobInformation,
): JobDetails | undefined => {
  if (!jobInfo) {
    return undefined;
  }

  const { salaryMin, salaryCurrency, internalReference } = jobInfo;

  return {
    id: `${jobInfo.jobId}`,
    adType: jobInfo.adType ?? undefined,
    productDisplayName: jobInfo.productDisplayName ?? undefined,
    createdBy:
      jobInfo.postChannel === JobPostChannel.DIRECT
        ? jobInfo.postedBy
        : undefined,
    createdDate: jobInfo.positionCreatedDate,
    expiryDate: jobInfo.expiredDate ?? undefined,
    locations: jobInfo.locations,
    internalReference,
    status: jobInfo.status,
    workType: jobInfo.workType ?? undefined,
    classification: jobInfo.classification
      ? {
          categoryName: jobInfo.classification,
          subCategoryName: jobInfo.subClassification ?? undefined,
        }
      : undefined,
    salary:
      typeof salaryMin === 'number' && salaryCurrency
        ? {
            salaryCurrency,
            salaryType: jobInfo.salaryType ?? undefined,
            salaryMin,
            salaryMax: jobInfo.salaryMax ?? undefined,
            salaryIsHidden: !Boolean(jobInfo.salary),
          }
        : undefined,
  };
};
